import React, { useEffect, useState } from "react";
import { roomOptions, roomLoadError } from "../../helpers/roomOptions";
import Select from "react-select";
import { useParams, useNavigate } from "react-router-dom";
import { Table, Tabs, Tab, Button, Modal, Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { FaEdit, FaTrash } from "react-icons/fa";
import {
  addMenuItemsForCustomerAPI,
  getCustomerMenuByCustomerIdAPI,
  getAllmenuAPI,
  updateMenuItemsForCustomerAPI,
  deletemenuitemcustomerAPI,
  getActiveReservations,
  // ✅ REMOVED: createFoodBilling import — the backend addMenuItemsForCustomer
  //    already creates the FoodBilling row. Calling it again from here was the
  //    source of duplicate rows and invoice_number unique-constraint crashes.
} from "../../helpers/api.ts";

const Menudetails = ({ userData }) => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("bills");
  const [menuTypes, setMenuTypes] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [allMenuData, setAllMenuData] = useState([]);
  const [selectedMenuId, setSelectedMenuId] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [selectedMenuPrice, setSelectedMenuPrice] = useState(0);
  const [menuDetails, setMenuDetails] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [updateItem, setUpdateItem] = useState(null);
  
  const [reservationContext, setReservationContext] = useState({
    reservation_id: null,
    billing_type: "direct"
  });

  const [availableReservations, setAvailableReservations] = useState([]);
  const [showReservationLookup, setShowReservationLookup] = useState(false);
  const [hadItems, setHadItems] = useState(false); // ✅ ADD THIS LINE


  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      fetchCustomerMenuByCustomerId(id);
    }
    fetchMenuTypes();
  }, [id]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const reservationId = urlParams.get('reservation_id');
    const billingType = urlParams.get('billing_type');

    if (reservationId) {
      setReservationContext({
        reservation_id: reservationId,
        billing_type: billingType || 'room'
      });
    }
  }, []);

  const fetchAvailableReservations = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      let hotel_id;
      if(user?.role === "RECEPTIONIST"){
        hotel_id = user?.hotel?.hotel_id;
      } else{
        hotel_id = user?.hotel_id;
      }

      const response = await getActiveReservations(hotel_id ?? user?.hotel?.hotel_id ?? user?.hotel_id);
      if (response.success) {
        setAvailableReservations(response.reservations || []);
      } else {
        toast.error(roomLoadError(null, response));
      }
    } catch (error) {
      console.error('Error fetching reservations:', error);
      toast.error(roomLoadError(error));
    }
  };

  const fetchCustomerMenuByCustomerId = async (customerId) => {
    try {
      const response = await getCustomerMenuByCustomerIdAPI(customerId, userData);
      
      if (response.success) {
        const formattedMenuDetails = response.data.map((item) => ({
          dish: item.dish,
          type: item.type,
          quantity: item.quantity,
          cost: item.cost,
          totalItemCost: item.finalAmount,
          menuId: item.menuId,
          billing_type: item.billing_type,
          reservation_id: item.reservation_id,
          id: item.id,
        }));
        
        setMenuDetails(formattedMenuDetails);
        if (formattedMenuDetails.length > 0) setHadItems(true); // ✅ ADD THIS LINE
      } else {
        toast.error(response.message || "Failed to fetch customer menu.");
        setMenuDetails([]);
      }
    }catch(error){

    }
  
  }

  const fetchMenuTypes = async () => {
    try {
      const response = await getAllmenuAPI();
      if (response.success) {
        setAllMenuData(response.data);
        
        const uniqueTypes = [
          ...new Set(response.data.map((item) => item.type)),
        ];
        setMenuTypes(uniqueTypes.map((type) => ({ label: type, value: type })));
      } else {
        toast.error(response.message || "Failed to fetch menu types.");
      }
    } catch (error) {
      console.error("Error fetching menu types:", error);
    }
  };

  const fetchMenuItemsByType = async (type) => {
    try {
      const response = await getAllmenuAPI();
      if (response.success) {
        const filteredItems = response.data.filter(
          (item) => item.type === type
        );
        setMenuItems(
          filteredItems.map((item) => ({ 
            label: `${item.dish} - ₹${item.cost}`, 
            value: item.id,
            price: item.cost,
            dish: item.dish
          }))
        );
      } else {
        toast.error(response.message || "Failed to fetch menu items.");
        setMenuItems([]);
      }
    } catch (error) {
      console.error("Error fetching menu items:", error);
      toast.error("Failed to fetch menu items.");
    }
  };

  const handleMenuItemSelect = (selectedOption) => {
    setSelectedMenuId(selectedOption);
    setSelectedMenuPrice(selectedOption?.price || 0);
  };

  const handleUpdateMenuItem = (item) => {
    setUpdateItem(item);
    setUpdateModal(true);
    fetchMenuItemsByType(item.type);
    setSelectedMenuPrice(item.cost);
    
    if (item.billing_type || item.reservation_id) {
      setReservationContext({
        reservation_id: item.reservation_id || null,
        billing_type: item.billing_type || 'direct'
      });
    }
  };

  const handleUpdateMenuItemSelect = (selectedOption) => {
    setUpdateItem({
      ...updateItem,
      menuId: selectedOption.value,
      dish: selectedOption.dish,
      cost: selectedOption.price,
    });
    setSelectedMenuPrice(selectedOption.price);
  };

const handleUpdateSubmit = async () => {
  if (!updateItem || updateItem.quantity < 1) {
    toast.error("Please select a valid quantity.");
    return;
  }

  // ✅ CRITICAL: Include the CustomerMenu record ID so backend can find the exact record to update
  const payload = {
    menuItems: [
      {
        id: updateItem.id,  // ✅ CRITICAL: This is the CustomerMenu.id (the record ID, not menuId)
        menuId: updateItem.menuId,
        quantity: updateItem.quantity,
      },
    ],
    reservation_id: reservationContext.billing_type === 'room' ? reservationContext.reservation_id : null,
    billing_type: reservationContext.billing_type || 'direct'
  };

  console.log("📤 Update payload:", payload);

  try {
    const response = await updateMenuItemsForCustomerAPI(id, payload);
    if (response.success) {
      toast.success("Menu item updated successfully.");
      await fetchCustomerMenuByCustomerId(id);
      handleUpdateModalClose();
    } else {
      toast.error(response.message || "Failed to update menu item.");
    }
  } catch (error) {
    console.error("Error updating menu item:", error);
    toast.error("Failed to update menu item.");
  }
};

 const handleDeleteMenuItem = async (item) => {
  try {
    const response = await deletemenuitemcustomerAPI(
      id,                           // customer_id
      item.menuId,                  // menuId  
      item.reservation_id ?? null,  // ✅ reservation_id (FIX)
      userData                      // userData
    );
    
    if (response.success) {
      toast.success(`${item.dish} has been deleted.`);
      setMenuDetails(prevDetails => 
        prevDetails.filter(detail => detail.menuId !== item.menuId)
      );
      await fetchCustomerMenuByCustomerId(id);
    } else {
      toast.error(response.message || "Failed to delete menu item.");
    }
  } catch (error) {
    console.error("❌ Error deleting menu item:", error);
    toast.error("Failed to delete menu item.");
  }
};

  const handleMenuTypeSelect = (selectedType) => {
    fetchMenuItemsByType(selectedType.value);
    setSelectedMenuId(null);
    setSelectedMenuPrice(0);
    setQuantity(1);
    if (updateModal) {
      setUpdateItem({
        ...updateItem,
        type: selectedType.value,
        menuId: null,
        dish: '',
        cost: 0,
      });
    }
  };

  // ✅ FIXED: Single API call only. The backend addMenuItemsForCustomer controller
  //    already creates both the CustomerMenu row AND the FoodBilling row in one
  //    transaction. No separate createFoodBilling call needed.
  const handleSubmit = async () => {
    if (!selectedMenuId || quantity < 1) {
      toast.error("Please select a menu item and provide a valid quantity.");
      return;
    }

    const payload = {
      id,
      menuItems: [{ menuId: selectedMenuId.value, quantity }],
      reservation_id: reservationContext.billing_type === 'room' ? reservationContext.reservation_id : null,
      billing_type: reservationContext.billing_type || 'direct'
    };

    try {
      const response = await addMenuItemsForCustomerAPI(payload);
      
      if (response.success) {
        toast.success("Menu items added successfully.");
        await fetchCustomerMenuByCustomerId(id);
        handleModalClose();
      } else {
        toast.error(response.message || "Failed to add menu items.");
      }
    } catch (error) {
      console.error("❌ Error adding menu items:", error);
      toast.error("Failed to add menu items.");
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setMenuItems([]);
    setSelectedMenuId(null);
    setSelectedMenuPrice(0);
    setQuantity(1);
  };

  const handleUpdateModalClose = () => {
    setUpdateModal(false);
    setUpdateItem(null);
    setSelectedMenuPrice(0);
  };

  const handleModalShow = () => {
    setShowModal(true);
  };

  const calculateTotal = () => {
    return selectedMenuPrice * quantity;
  };

  const calculateGrandTotal = () => {
    return menuDetails.reduce((total, item) => {
      return total + (item.totalItemCost || 0);
    }, 0);
  };

  return (
    <div className="container" style={{ marginTop: "10%" }}>
      <ToastContainer />
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-4"
      >
        <Tab eventKey="bills">
          <div className="d-flex justify-content-between align-items-center flex-column flex-md-row gap-2">
            <div className="w-100">
              {reservationContext.reservation_id && (
                <div className="alert alert-info d-inline-block mb-0">
                  <i className="fas fa-bed me-2"></i>
                  <strong>Reservation Mode:</strong> Orders will be charged to Reservation #{reservationContext.reservation_id}
                </div>
              )}
            </div>
            <Button
              variant="secondary"
              onClick={() => navigate("/Customer-menu")}
              className="w-100 w-md-auto btn-sm"
            >
              Back
            </Button>
          </div>
          <div className="d-flex justify-content-start mb-3">
            <Button variant="primary" onClick={handleModalShow} className="w-100 w-md-auto">
              Add Menu Items
            </Button>
          </div>

        

          <div className="table-responsive">
            <Table className="table-bordered">
              <thead>
                <tr className="text-center">
                  <th>#</th>
                  <th>Dish</th>
                  <th className="d-none d-md-table-cell">Type</th>
                  <th>Quantity</th>
                  <th className="d-none d-lg-table-cell">Cost</th>
                  <th className="d-none d-md-table-cell">Total Cost</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody className="text-center">
                {menuDetails.length > 0 ? (
                  menuDetails.map((item, index) => (
                    <tr key={`${item.menuId}-${index}`}>
                      <td>{index + 1}</td>
                      <td>
                        <div className="d-flex flex-column">
                          <span>{item.dish}</span>
                          <small className="text-muted d-md-none">{item.type}</small>
                        </div>
                      </td>
                      <td className="d-none d-md-table-cell">{item.type}</td>
                      <td>{item.quantity}</td>
                      <td className="d-none d-lg-table-cell">₹{item.cost}</td>
                      <td className="d-none d-md-table-cell">₹{item.totalItemCost}</td>
                      <td>
                        <div className="d-flex gap-1 justify-content-center">
                          <Button
                            variant="warning"
                            size="sm"
                            onClick={() => handleUpdateMenuItem(item)}
                          >
                            <FaEdit />
                          </Button>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleDeleteMenuItem(item)}
                          >
                            <FaTrash />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                   <td colSpan="7">
      {/* ✅ Only show message if customer previously had items (all deleted), 
           not on first-time empty state */}
      {hadItems ? "No menu items found for this customer." : ""}
    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Tab>
      </Tabs>

      {/* Add Menu Item Modal */}
      <Modal show={showModal} onHide={handleModalClose} className="modal-fullscreen-md-down">
        <Modal.Header closeButton>
          <Modal.Title>Add Menu Items</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Select Menu Type</Form.Label>
              <Select
                options={menuTypes}
                onChange={handleMenuTypeSelect}
                placeholder="Select Menu Type"
              />
            </Form.Group>
            <Form.Group className="mt-3">
              <Form.Label>Select Menu Item</Form.Label>
              <Select
                options={menuItems}
                value={selectedMenuId}
                onChange={handleMenuItemSelect}
                placeholder="Select Menu Item"
              />
            </Form.Group>
            
            {selectedMenuId && (
              <div className="mt-3 p-3 bg-light rounded">
                <div className="d-flex justify-content-between">
                  <span><strong>Item:</strong> {selectedMenuId.dish}</span>
                  <span><strong>Price:</strong> ₹{selectedMenuPrice}</span>
                </div>
              </div>
            )}
            
            <Form.Group className="mt-3">
              <Form.Label>Quantity</Form.Label>
              <Form.Control
                type="number"
                min="1"
                value={quantity}
                onChange={(e) => setQuantity(Number(e.target.value))}
              />
            </Form.Group>

            {selectedMenuId && quantity > 0 && (
              <div className="mt-3 p-3 bg-success bg-opacity-10 rounded">
                <h5 className="mb-0">
                  <strong>Total Amount:</strong> ₹{calculateTotal()}
                </h5>
              </div>
            )}

            <Form.Group className="mt-3">
              <Form.Label>Billing Type</Form.Label>
              <Form.Select
                value={reservationContext.billing_type}
                onChange={(e) => setReservationContext(prev => ({
                  ...prev,
                  billing_type: e.target.value
                }))}
              >
                <option value="direct">Direct Billing (Walk-in)</option>
                <option value="room">Charge to Room</option>
              </Form.Select>
            </Form.Group>

            {reservationContext.billing_type === "room" && (
              <Form.Group className="mt-3">
                <Form.Label>Select Room</Form.Label>
                <div className="d-flex gap-2">
                  <Button 
                    variant="outline-primary" 
                    onClick={() => {
                      fetchAvailableReservations();
                      setShowReservationLookup(!showReservationLookup);
                    }}
                    className="w-100"
                  >
                    <i className="fas fa-search me-2"></i>
                    {reservationContext.reservation_id ? 
                      `Room Selected (ID: ${reservationContext.reservation_id})` : 
                      'Search by Room Number'
                    }
                  </Button>
                </div>
                
                {showReservationLookup && (
                  <div className="mt-2">
                    <Form.Label>Search by Room Number:</Form.Label>
                    <Select
                      options={roomOptions(availableReservations)}
                      onChange={(selectedOption) => {
                        setReservationContext(prev => ({
                          ...prev,
                          reservation_id: selectedOption.value
                        }));
                        setShowReservationLookup(false);
                      }}
                      placeholder="Type room number to search..."
                      noOptionsMessage={() => "No checked-in room found"}
                      isSearchable
                      isClearable
                    />
                  </div>
                )}
                
                <Form.Text className="text-muted">
                  This order will be charged to the room reservation
                </Form.Text>
              </Form.Group>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Add Items
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Update Menu Item Modal */}
      <Modal show={updateModal} onHide={handleUpdateModalClose} className="modal-fullscreen-md-down">
        <Modal.Header closeButton>
          <Modal.Title>Update Menu Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Select Menu Type</Form.Label>
              <Select
                options={menuTypes}
                value={{ label: updateItem?.type, value: updateItem?.type }}
                onChange={handleMenuTypeSelect}
                placeholder="Select Menu Type"
              />
            </Form.Group>
            <Form.Group className="mt-3">
              <Form.Label>Select Menu Item</Form.Label>
              <Select
                options={menuItems}
                value={updateItem ? { 
                  label: `${updateItem.dish} - ₹${updateItem.cost}`, 
                  value: updateItem.menuId,
                  price: updateItem.cost,
                  dish: updateItem.dish
                } : null}
                onChange={handleUpdateMenuItemSelect}
                placeholder="Select Menu Item"
              />
            </Form.Group>
            
            {updateItem && (
              <div className="mt-3 p-3 bg-light rounded">
                <div className="d-flex justify-content-between">
                  <span><strong>Item:</strong> {updateItem.dish}</span>
                  <span><strong>Price:</strong> ₹{updateItem.cost || selectedMenuPrice}</span>
                </div>
              </div>
            )}
            
            <Form.Group className="mt-3">
              <Form.Label>Quantity</Form.Label>
              <Form.Control
                type="number"
                value={updateItem ? updateItem.quantity : ""}
                min="1"
                onChange={(e) =>
                  setUpdateItem({
                    ...updateItem,
                    quantity: Number(e.target.value),
                  })
                }
              />
            </Form.Group>

            {updateItem && updateItem.quantity > 0 && (
              <div className="mt-3 p-3 bg-success bg-opacity-10 rounded">
                <h5 className="mb-0">
                  <strong>Total Amount:</strong> ₹{(updateItem.cost || selectedMenuPrice) * updateItem.quantity}
                </h5>
              </div>
            )}

            <Form.Group className="mt-3">
              <Form.Label>Billing Type</Form.Label>
              <Form.Select
                value={reservationContext.billing_type}
                onChange={(e) => setReservationContext(prev => ({
                  ...prev,
                  billing_type: e.target.value
                }))}
              >
                <option value="direct">Direct Billing (Walk-in)</option>
                <option value="room">Charge to Room</option>
              </Form.Select>
            </Form.Group>

            {reservationContext.billing_type === "room" && (
              <Form.Group className="mt-3">
                <Form.Label>Select Room</Form.Label>
                <div className="d-flex gap-2">
                  <Button 
                    variant="outline-primary" 
                    onClick={() => {
                      fetchAvailableReservations();
                      setShowReservationLookup(!showReservationLookup);
                    }}
                    className="w-100"
                  >
                    <i className="fas fa-search me-2"></i>
                    {reservationContext.reservation_id ? 
                      `Room Selected (ID: ${reservationContext.reservation_id})` : 
                      'Search by Room Number'
                    }
                  </Button>
                </div>
                
                {showReservationLookup && (
                  <div className="mt-2">
                    <Form.Label>Search by Room Number:</Form.Label>
                    <Select
                      options={roomOptions(availableReservations)}
                      onChange={(selectedOption) => {
                        setReservationContext(prev => ({
                          ...prev,
                          reservation_id: selectedOption.value
                        }));
                        setShowReservationLookup(false);
                      }}
                      placeholder="Type room number to search..."
                      noOptionsMessage={() => "No checked-in room found"}
                      isSearchable
                      isClearable
                    />
                  </div>
                )}
                
                <Form.Text className="text-muted">
                  This order will be charged to the room reservation
                </Form.Text>
              </Form.Group>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleUpdateModalClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleUpdateSubmit}>
            Update Item
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Menudetails;